import { clientPath, lpRequest } from '../../../../core/utils/lp-backend';

const URL_KEYS = ['location', 'general', 'transaction'];
const EVENT_KEYS = [
  'order_events',
  'trip_events',
  'task_events',
  'driver_events',
  'wallet_events',
  'transaction_events'
];

/**
 * The client's webhooks from `GET /client/:cid/webhooks/all`: all nine keys `PUT /client/:cid/webhooks` replaces, as
 * stored, `null` where never set (shown as an empty URL or no events).
 */
export const readWebhooks = async (): Promise<{ webhooks: any }> => {
  const stored = await lpRequest('GET', clientPath('/webhooks/all'));

  const webhooks: Record<string, any> = Object.fromEntries([
    ...URL_KEYS.map((key) => [key, stored[key] ?? '']),
    ...EVENT_KEYS.map((key) => [key, stored[key] ?? {}])
  ]);
  // The form's order event is `near_by`; some clients store it as `nearby`.
  const order_events = { ...webhooks.order_events };
  order_events.near_by = order_events.near_by ?? order_events.nearby ?? false;
  delete order_events.nearby;

  return { webhooks: { ...webhooks, order_events } };
};
